export enum BoxBreakModal {
  BOX_BREAK_END_MODAL = "BOX_BREAK_END_MODAL",
  BOX_BREAK_UNRECOGNIZED_BARCODE = "BOX_BREAK_UNRECOGNIZED_BARCODE",
  BOX_BREAK_CONFIRM_OVERAGE_SCAN = "BOX_BREAK_CONFIRM_OVERAGE_SCAN",
  BOX_BREAK_SELLER_MISMATCH_MODAL = "BOX_BREAK_SELLER_MISMATCH_MODAL",
  BOX_BREAK_UNEXPECTED_SKU_NO_CAPABLE_WAREHOUSES = "BOX_BREAK_UNEXPECTED_SKU_NO_CAPABLE_WAREHOUSES",
}
